<template>
  <div>
    <!-- <div class="filterButtonPosition" style="right: 64px">
      <f7-button
        fill
        class="whiteFontColor button-filter"
        panel-toggle="right"
      >
        <span class="ic-filter"></span> {{ $t('filter') }}
      </f7-button>
    </div> -->
    <DxDataGrid
      ref="dataGrid"
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid custom-grid-detail-Mining"
      :no-data-text="$t('noDataTextDetail')"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
      @content-ready="init"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="miningSamplesDetailsTable_v2"
      />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />
      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />
      <DxExport :enabled="true" />

      <DxColumn
        data-field="parameter_group"
        :caption="$t('group')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parameter"
        :caption="$t('foodSamples.parameter')"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="result_value"
        cell-template="cellTemplateResultadoPresentacion"
        :caption="$t('foodSamples.result')"
        :calculate-cell-value="calculateResultValue"
        :allow-header-filtering="false"
      />

      <template #cellTemplateResultadoPresentacion="{ data }">
        <div>
          {{
            data.data.value.ResultadoPresentacion.includes(
              'En Proceso'
            )
              ? $t('inProcess')
              : data.data.value.ResultadoPresentacion
          }}
        </div>
      </template>

      <DxColumn
        data-field="unit_value"
        :caption="$t('foodSamples.unit')"
        :calculate-cell-value="calculateUnitValue"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="range_value"
        :caption="$t('foodSamples.range')"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateRange"
      />
    </DxDataGrid>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('samples', ['reportSampleCode']),
  },
  methods: {
    calculateRange(rowData) {
      return `${rowData.value.r_min} - ${rowData.value.r_max}`;
    },
    calculateUnitValue(rowData) {
      return rowData?.value?.unit ?? '';
    },
    calculateResultValue(rowData) {
      return rowData?.value?.ResultadoPresentacion ?? '';
    },
    init(e) {
      this.setSampleDetails(e.component.getDataSource().items());
    },
    onExporting(e) {
      this.setIsExporting(true);
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        `${`${this.$t(
          'agronomySample.summary.sampleSummary'
        )}-${this.$t('Mining')}`}`
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `besafer-${this.reportSampleCode}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'after';
        }
        if (item.name === 'exportButton') {
          item.location = 'after';
        }

        // if (item.name === 'groupPanel') {
        //   item.location = 'after';
        // }
      });

      toolbarItems.push({
        name: 'Filtros',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: '',
          icon: '././static/icons/ic_filter.svg',
          width: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    ...mapActions('miningSamples', [
      'setSampleDetails',
      'setIsExporting',
    ]),
  },
};
</script>

<style>
.custom-grid-detail-Mining .dx-searchbox {
  width: 200px !important;
}
.custom-grid-detail-Mining .dx-toolbar-after {
  display: grid;
  grid-template-columns: 100px 107px 48px 37px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-Mining .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-detail-Mining .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-Mining .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
  justify-self: start;
}
/* Input más grande */
.custom-grid-detail-Mining .dx-searchbox .dx-texteditor-input {
  padding-left: 36px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* Contenedor */
.custom-grid-detail-Mining .dx-searchbox {
  position: relative;
  height: 40px !important;
}

/* ICONO */
.custom-grid-detail-Mining .dx-searchbox::before {
  content: '';
  position: absolute;

  left: 7px;
  top: 45%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;

  background-image: url('@/static/icons/ic_search_blue.svg');
  background-repeat: no-repeat;
  background-size: 24px 24px;

  pointer-events: none;
}
</style>
